import React from 'react';

const PageLoader: React.FC = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block w-10 h-10 border-4 border-slate-200 border-t-slate-900 rounded-full animate-spin mb-4"></div>
        <p className="text-slate-500 text-sm">Loading...</p>
      </div>
    </div>
  );
};

export default PageLoader;
